<template>
  <div>
    <hr />

    <DataTable
      :data="suscpagos"
      :columns="columnas"
      idField="idSuscPago"
      mensajeVacio="No hay pagos de suscripción registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idSuscPago)"
      @view="row => abrirEditar(row.idSuscPago)"
      @delete="row => deleteSuscPago(row.idSuscPago)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar..."
            style="width:200px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Fechas formateadas -->
      <template #cell-fechaDesde="{ row }">
        {{ getFormattedDate(row.fechaDesde) }}
      </template>
      <template #cell-fechaHasta="{ row }">
        {{ getFormattedDate(row.fechaHasta) }}
      </template>
      <template #cell-suscripcionFechaReg="{ row }">
        {{ getFormattedDate(row.suscripcionFechaReg) }}
      </template>
      <template #cell-facturaFechaReg="{ row }">
        {{ getFormattedDate(row.facturaFechaReg) }}
      </template>

      <!-- Estado de pago con badge -->
      <template #cell-estadoPago="{ row }">
        <span class="badge" :class="badgeEstadoPago(row.estadoPago)">
          {{ row.estadoPago }}
        </span>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscPago.idSuscPago"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Suscripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Suscripción</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoSuscPago.idSuscripcion">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="s in suscripcions"
                        :value="s.idSuscripcion"
                        :key="s.idSuscripcion"
                      >
                        {{ s.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Factura -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Factura</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoSuscPago.idFactura">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="f in facturas"
                        :value="f.idFactura"
                        :key="f.idFactura"
                      >
                        {{ f.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Estado de Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Estado de Pago</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscPago.estadoPago"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Desde -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Desde</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSuscPago.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Hasta -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Hasta</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSuscPago.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarSuscPago"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarSuscPago"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config          from "@/config";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "SuscPagoList",
  components: { DataTable },

  props: {
    p_idSuscripcion: { type: Number, required: true },
  },

  data() {
    return {
      suscpagos:    [],
      datoSuscPago: {},
      nombreBusqueda: "",
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      suscripcions: [],
      facturas:     [],
    };
  },

  computed: {
    columnas() {
      return [
        // estadoPago usa slot #cell-estadoPago para badge
        { label: "Estado Pago",        field: "estadoPago"          },
        // fechas usan slots #cell-* para formateo
        { label: "Fecha Desde",        field: "fechaDesde"          },
        { label: "Fecha Hasta",        field: "fechaHasta"          },
        { label: "Suscripción F. Reg", field: "suscripcionFechaReg" },
        { label: "Factura F. Reg",     field: "facturaFechaReg"     },
      ];
    },
  },

  mounted() {
    this.getData();
    this.fetchSuscripcions();
    this.fetchFacturas();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    badgeEstadoPago(estado) {
      const e = (estado ?? "").toUpperCase();
      return {
        "bg-success":           e === "PAGADO",
        "bg-warning text-dark": e === "PENDIENTE",
        "bg-danger":            e === "VENCIDO",
        "bg-secondary":         !["PAGADO", "PENDIENTE", "VENCIDO"].includes(e),
      };
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwsuscpagos")
        .then(r => { this.suscpagos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar pagos de suscripción:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwsuscpagos/nombre/" + nombre)
        .then(r => { this.suscpagos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar pago:", e));
    },

    // ── Fetch auxiliares (usando fetch + config igual que el original) ─
    fetchSuscripcions() {
      fetch(config.apiBaseUrl + "/suscripcions")
        .then(r => r.json())
        .then(data => { this.suscripcions = data; })
        .catch(e => console.error("Error fetching suscripcions:", e));
    },

    fetchFacturas() {
      fetch(config.apiBaseUrl + "/facturas")
        .then(r => r.json())
        .then(data => { this.facturas = data; })
        .catch(e => console.error("Error fetching facturas:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoSuscPago,
        ["idSuscripcion", "idFactura", "estadoPago", "fechaDesde", "fechaHasta"],
        ["Suscripción", "Factura", "Estado de Pago", "Fecha Desde", "Fecha Hasta"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarSuscPago() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/suscpagos", this.datoSuscPago);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Pago creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarSuscPago() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/suscpagos", this.datoSuscPago);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Pago actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteSuscPago(idSuscPago) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar pago?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/suscpagos/" + idSuscPago);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoSuscPago = { idSuscripcion: this.p_idSuscripcion };
      this.titulo       = "Crear Pago por Suscripción";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idSuscPago) {
      this.modalWindow = true;
      this.titulo      = "Editar Pago por Suscripción";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwsuscpagos/" + idSuscPago);
        this.datoSuscPago = resp.data;
        // Normalizar fechas para input type="date"
        if (this.datoSuscPago.fechaDesde)
          this.datoSuscPago.fechaDesde = this.datoSuscPago.fechaDesde.slice(0, 10);
        if (this.datoSuscPago.fechaHasta)
          this.datoSuscPago.fechaHasta = this.datoSuscPago.fechaHasta.slice(0, 10);
      } catch (e) {
        console.error("Error al cargar pago:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idSuscPago) {
      if (idSuscPago != null) this.$router.push("/suscpagomd/" + idSuscPago);
    },
  },
};
</script>